import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import getAllServiceRequestsRes from './getAllServiceRequest.json';
import getAllRefundRes from './getAllRefund.json';
import getAllByTypeRes from '../user/getAllByType.json';

const getAllServiceRequests = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-servicerequests?size=${size ?? 10}&page=${page ?? 0}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllServiceRequestsRes>(url, config);
};

const getServiceById = (id?: number | string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-service?serviceId=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllServiceRequestsRes>(url, config);
};

const getAllByType = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}users-by-role?roleId=7`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllByTypeRes>(url, config);
};

const getInvoicesByServiceId = (serviceId?: string | number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-service-invoices-by-service?serviceId=${serviceId}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  if (serviceId) {
    return axios.get(url, config);
  }
  return {};
};

const getInvoicesByName = (name?: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-client-service-invoices?clientName=${name}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  if (name) {
    return axios.get(url, config);
  }
  return {};
};

const getAllServiceRequestsByStatus = (serviceStatus?: number | string, page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-servicerequests-bystatus?serviceStatus=${serviceStatus ?? ''}&page=${page ?? 0}&size=${size ?? 10}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllServiceRequestsRes>(url, config);
};

const getAllRefund = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-refund?size=${size ?? 10}&page=${page ?? 0}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRefundRes>(url, config);
};

const getAllPaidRefund = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-paid-refunds?size=${size ?? 10}&page=${page ?? 0}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRefundRes>(url, config);
};

const getAllUnPaidRefund = (page?: number, size?: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-unpaid-refunds?size=${size ?? 10}&page=${page ?? 0}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllRefundRes>(url, config);
};

interface SendRefund {
  id: number | string;
  refundAmount: number;
}

const sendRefund = (data: SendRefund) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}send-refund`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface AddRefundRequestData {
  'firstname': string,
  'lastname': string,
  'phoneNumber': string,
  'email': string,
  'address': {
    'streetAddress': string;
    'zipCode': string;
    'state': string;
    'city': string;
  },
  'requestAmount': number;
  'refundReason': number;
  'comment': string;
  'vmId': number;
}

const addRefundRequest = (data: AddRefundRequestData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}customer-refund`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface AddServiceInvoiceData {
  'serviceId': number;
  'serviceDate': string; // "12/21/2021",
  'parts': string[]; // ["part:price","part:price"]
  'laborHour': number;
  'laborRate': number;
  'description': string;
  'discount': number;
  'billAmount': number;
}

const addServiceInvoice = (data: AddServiceInvoiceData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-service-invoice`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface SendInvoice {
  'file': any;
  'email': string;
  'name': string;
}

const sendInvoice = (data: any) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}send-invoice`;
  const config = {
    headers: {
      Authorization: `${ACCESS_TYPE} ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
  return axios.post(url, { ...data }, config);
};

const getPDFByInvoiceId = (id: number | null) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-service-invoice-pdf?invoiceId=${id}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  });
};

interface AddServiceRequestData {
  'clientName': number;
  'comment': string;
  'email': string;
  'firstname': string;
  'lastname': string;
  'phoneNumber': string;
  'serviceReason': number;
  'sms': boolean;
  'vmId': number;
}

const addServiceRequest = (data: AddServiceRequestData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-servicerequest`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

interface UpdateServiceRequestData {
  'id': number;
  'serviceStatus': number | null;
  'priority': number | null;
  'userId': number | null;
  'scheduleDate': Date | string | null;
  'comment': string | null;
}

const updateServiceRequest = (data: UpdateServiceRequestData) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-service-request`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, { ...data }, config);
};

const customerSupport = {
  getAllServiceRequestsByStatus,
  getAllServiceRequests,
  getAllRefund,
  getAllPaidRefund,
  getAllUnPaidRefund,
  sendRefund,
  addRefundRequest,
  addServiceInvoice,
  addServiceRequest,
  updateServiceRequest,
  getServiceById,
  getInvoicesByName,
  getInvoicesByServiceId,
  getAllByType,
  sendInvoice,
  getPDFByInvoiceId,
};

export default customerSupport;
